<div class="promo-content-wrapper">
  <div class="content-centered">
    <img src="/assets/icon_sad_{{ userSettingsStore.colorMode$ | async }}.svg" alt="" />
    <h3>{{ 'Rooms Instance Not Configured' | translate }}</h3>
    <p>
      {{
        'This Rooms instance is not configured yet. Please verify the URL or reach out to the administrator for assistance. Want to create your own space for trusted communication?'
          | translate
      }}
    </p>
    <a href="https://app.tarif-config.4players.de/config/206/en_GB?customize=true">
      <andor-button type="gradient">
        <span>{{ 'Get Started' | translate }}</span>
      </andor-button>
    </a>
  </div>
</div>
